
import React, { act, useEffect, useState } from "react";
import BackButton from "./Backbutton";
import Title from "./Title";
import { useParams } from "react-router-dom";
import { apiHandler } from "../../utils/apiHandler";
import { EVENT_BASEURL } from "../../utils/Constants";

const Journey = () => {
  const { id } = useParams();
  const [response, setResponse] = useState(null);
  const [tickets, setTickets] = useState([
  ]);
  const [activeCardId, setActiveCardId] = useState(null); // To track the currently open card
  const [isLastChunkOpen, setIsLastChunkOpen] = useState(false);
  const [canclose, setyesoneifopen] = useState(false);
  const [canslode, setcatclose] = useState("");
  const [disabledCards, setDisabledCards] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1025);
  const [isSticky, setIsSticky] = useState(false);
  const [slideInImg, setSlideImgIn] = useState([]);
  const [currentImageIndexWeb, setCurrentImageIndexWeb] = useState(0);
  const [isActiveImg, setIsActiveImg] = useState(false)
    const [isImageLoaded, setIsImageLoaded] = useState(true);
  let animationFrameId = null;
let NewUsername = "";

const pathArray = window.location.pathname.split("/").filter(Boolean);

if (pathArray.includes("Login")) {
    // Handle special case when URL contains "Login"
    NewUsername = pathArray[1];
} else {
    NewUsername = pathArray[0] 
}

let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
console.log(newImgUrl);

  useEffect(() => {
    const fetchFunction = async () => {
      try {
        const res = await apiHandler.post("/guest/fetch-feature", {
          _id: id,
          category: "Journeys"
        });
        setSlideImgIn(res?.journeysWebImgs)
        if (res && res.journeys) {
          setResponse(res);
          // Transform the journeys array
          const transformedTickets = res.journeys.map((item, index) => ({
            id: index,
            name: item.journeyDetails,
            img: `${newImgUrl + item.journeyImg}`, // Adjust path as needed
            text: item.journeySubHeading,
            journeyHeading: item.journeyHeading,
            // active: index === 0, // Make the first item active
          }));

          setTickets(transformedTickets);
        }
      } catch (err) {
        console.error("Guest login error:", err);
      }
    }

    fetchFunction();
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      animationFrameId = requestAnimationFrame(() => {
        const outerElement = document.querySelector('.scroll-bar');
        if (outerElement) {
          const scrollPosition = outerElement.scrollTop;
          setIsSticky(scrollPosition > 0);
        }
      });
    };

    const outerElement = document.querySelector('.scroll-bar');
    if (outerElement) {
      outerElement.addEventListener('scroll', handleScroll);
      handleScroll(); // Initial check

      return () => {
        outerElement.removeEventListener('scroll', handleScroll);
        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }
      };
    }
  }, [tickets]);



  const handleActive = (id, e) => {
    if (e) {
      e.preventDefault();
    }

    const clickedTicket = tickets.find((ticket) => ticket.id === id);
    const chunks = calculateChunks(clickedTicket);
    const totalDelay = chunks.length * 550;

    // Disable pointer events for the clicked card during the delay
    setDisabledCards((prev) => [...prev, id]);

    //
    setTickets((prevTickets) => {
      return prevTickets.map((ticket) => {
        if (ticket.id === id) {
          // Toggle the clicked card's active state
          return {
            ...ticket,
            active: !ticket.active,
            activeChunk: 0,
            disableClose: !ticket.active,
          };
        }

        // If the card is fully open, close it when a new card is opened
        if (ticket.active && ticket.activeChunk === chunks.length && id !== ticket.id) {

          return {
            ...ticket,
            active: false,
            activeChunk: 0,
            disableClose: !ticket.active,
          };
        }

        return ticket;
      });
    });

    // Update the active card ID
    if (clickedTicket.active) {
      setActiveCardId(null); // If closing, reset the activeCardId
    } else {
      setActiveCardId(id); // Set the new active card ID
    }

    // After the delay, update the catclose state and re-enable pointer events
    setTimeout(() => {
      const updatedTicket = tickets.find((ticket) => ticket.id === id);
      if (updatedTicket && updatedTicket.active) {
        console.log("Card is fully open");
        setcatclose("can");
      } else {
        setcatclose("cant");
      }

      // Re-enable pointer events after totalDelay
      setDisabledCards((prev) => prev.filter((cardId) => cardId !== id));
    }, totalDelay);
  };



  const calculateChunks = (ticket) => {
    if (!ticket || !ticket.name) {
      return [];
    }

    const words = ticket.name.split(" ");
    const chunks = [];
    let currentChunk = "";
    let chunkHeight = 0;
    let isFirstChunk = true;
    const maxChunkHeight = 145;
    const firstChunkExtraHeight = 80;
    const paddingLeftRight = 10; // Adjust as needed

    for (let i = 0; i < words.length; i++) {
      const word = words[i];
      const tempChunk = currentChunk ? `${currentChunk} ${word}` : word;

      const tempDiv = document.createElement("div");
      tempDiv.style.visibility = "hidden";
      tempDiv.style.position = "absolute";
      tempDiv.style.width = window.innerWidth > 1025 ? "22vw" : "90vw";
      tempDiv.style.paddingLeft = `${paddingLeftRight}px`;
      tempDiv.style.paddingRight = `${paddingLeftRight}px`;
      tempDiv.textContent = tempChunk;

      document.body.appendChild(tempDiv);
      chunkHeight = tempDiv.getBoundingClientRect().height;
      document.body.removeChild(tempDiv);

      if (
        (isFirstChunk && chunkHeight > maxChunkHeight - firstChunkExtraHeight) ||
        (!isFirstChunk && chunkHeight > maxChunkHeight)
      ) {
        if (currentChunk.trim() !== "") {
          chunks.push({ chunk: currentChunk.trim(), isFirstChunk });
        }
        currentChunk = word;
        isFirstChunk = false;
      } else {
        currentChunk = tempChunk;
      }
    }

    if (currentChunk.trim() !== "") {
      chunks.push({ chunk: currentChunk.trim(), isFirstChunk });
    }

    return chunks.map((chunkObj, index) => {
      const tempDiv = document.createElement("div");
      tempDiv.style.visibility = "hidden";
      tempDiv.style.position = "absolute";
      tempDiv.style.width = window.innerWidth > 1025 ? "22vw" : "90vw";
      tempDiv.style.paddingLeft = `${paddingLeftRight}px`;
      tempDiv.style.paddingRight = `${paddingLeftRight}px`;

      tempDiv.textContent = chunkObj.chunk;

      document.body.appendChild(tempDiv);
      const calculatedHeight = tempDiv.getBoundingClientRect().height;
      document.body.removeChild(tempDiv);

      return {
        chunk: chunkObj.chunk,
        height: index === chunks.length - 1 ? calculatedHeight + 10 : maxChunkHeight,
        isFirstChunk: chunkObj.isFirstChunk,

      };

    });


  };


  const handleChunkState = (ticket, chunkIndex, totalChunks) => {
    if (ticket.active && chunkIndex === totalChunks - 1) {
      setIsLastChunkOpen(true);
    }
  };

  useEffect(() => {
    // Check if all tickets are inactive
    const allInactive = tickets.every((ticket) => !ticket.active);
    // If all tickets are inactive, activate the ticket with id 0
    if (allInactive) {

      setIsActiveImg(true)

    } else {
      setIsActiveImg(false)
    }
  }, [tickets]);

  useEffect(() => {
    if (isLastChunkOpen) {
      // Perform actions when last chunk is open
    }
  }, [isLastChunkOpen]);

  let ticketsOdd = [];
  let ticketsEven = [];
  if (tickets.length > 0) {
    tickets.map((item, index) => {
      if (index % 2 === 0) {
        ticketsEven.push(item);
      } else {
        ticketsOdd.push(item);
      }
    });
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndexWeb((prev) =>
        prev === slideInImg.length - 1 ? 0 : prev + 1
      );
    }, 4000);
    return () => clearInterval(interval);
  }, [slideInImg.length]);
  return (
    <div className=" flex-row flex-wrap grid grid-cols-12  box   " style={{ maxHeight: "100svh", minHeight: "100svh", overflow: isMobile ? "scroll" : "", zIndex: '333333', backgroundColor: 'white' }} >
      <div className="col-span-5 relative h-screen overflow-hidden bg-cover bg-center bg-no-repeat  Removeinmobile parentdiv one ">
        <div className=" pt-0 flex items-center " id="pills-tabContent one">
          <div className="section__hero relative overflow-hidden bg-cover bg-center bg-no-repeat">
            {!isActiveImg ? tickets && tickets.map((ticket) => (
              <img
                key={ticket.id}
                src={`${ticket.img}`}
                alt=""
                className={`crossFade__image ${ticket.active ? "crossFade__image--active" : ""
                  }`}
                data-id={ticket.id}
              />
            )) :

              (slideInImg && slideInImg.map((ticket, index) => (

                <img
                  key={ticket.id}
                  src={`${newImgUrl + ticket}`}
                  alt=""
                    className={`w-full h-full relative z-[-1] object-cover crossFade__image ${
										currentImageIndexWeb === index ? 'crossFade__image--active' : ''
									}
									transition-all duration-500 ${
                    isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                }
									`}
															onLoad={() => setIsImageLoaded(false)}
                  data-id={ticket.id}
                />
              )))
            }
            <div
              className="absolute top-[40px] right-[40px] bottom-[40px] left-[40px] bg-white/0 py-[30px] px-[40px] border-[3px] border-white"
              style={{
                boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.7)",
              }}
            ></div>
          </div>
        </div>
      </div>

      <div className="  scroll-bar  w-full  md:col-span-7 px-0 overflow-y-scroll " style={{ height: isMobile ? "" : "100svh", overflowX: "hidden", display: isMobile ? "flex" : "", justifyContent: "center", alignItems: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }} className={`stickynav ${isSticky ? "isSticky" : "hideinmobile"}`}>
          <div
            className="    p-0 mb-0  joureny"

          >
            <Title title={"Our Journey"} textColor={"text-black"} style={{ fontSize: "2.5rem" }} />

          </div>
        </div>
        <ul
          className="nav nav-justified flex justify-center sticky-bar md:justify-evenly p-4"
          id="pills-tab"
          role="tablist"
        >
          <div className="flex flex-col flex-wrap justify-start items-center">
            {ticketsEven
              // .filter((ticket) => ticket.id !== 0)
              .map((ticket,index) => {
                const chunks = calculateChunks(ticket);
                const totalChunks = chunks.length;
                const chunkDelay = 0.36;
                const extraDelay = 0.25;

                return (
                  <li className="w-full carddiv flex justify-center p-2" key={ticket.id}>
                    <a
                      className="nav-link rounded"
                      id="proposal"
                      data-bs-toggle="pill"
                      href={"#" + ticket.id}
                      role="tab"
                      aria-controls="developing"
                      aria-selected="false"
                    >
                      <div
                        id="cardContainer"
                        style={{
                          transition: "1.9s",
                          pointerEvents: disabledCards.includes(ticket.id) ? 'none' : 'auto',

                        }}

                        onClick={(e) => handleActive(ticket.id, e)}
                      >
                        <div className="firstDisplayImg">
                          <div id="firstDisplay">
                            <img
                              src={ticket.img}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                              }}
                              className={`
									transition-all duration-500 ${
                    isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                }
									`}
															onLoad={() => setIsImageLoaded(false)}
                              alt=""
                            />
                          </div>
                        </div>
                        <div
                          id="first"
                          className={
                            ticket.active ? "firstheight active" : "firstheight"
                          }
                          style={{
                            transform: ticket.active
                              ? `rotate3d(1, 0, 0, -180deg)`
                              : `rotate3d(1, 0, 0, 0deg)`,
                            transitionDelay: ticket.active
                              ? "0.4s"
                              : `${totalChunks * chunkDelay}s`,

                          }}
                        >
                          <div id="firstTop">
                            <div
                              id="timecontainer"
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                              }}
                            >
                              <img
                                src={ticket.img}
                                style={{
                                  height: "100%",
                                  width: "100%",
                                  objectFit: "cover",
                                }}
                                className={`
									transition-all duration-500 ${
                    isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                }
									`}
															onLoad={() => setIsImageLoaded(false)}
                                alt=""
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0%",
                                  bottom: "0%",
                                  left: "0%",
                                  right: "0%",
                                  background: "rgba(0, 0, 0, 0.4)",
                                  zIndex: 2,
                                }}
                              ></div>
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                top: "12%",
                                bottom: "12%",
                                left: "5%",
                                right: "5%",
                                zIndex: 3,
                              }}
                            >
                              <div className="top-border"></div>
                              <div className="bottom-border"></div>
                              <div className="left-border"></div>
                              <div className="right-border"></div>
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                top: "0%",
                                left: "0%",
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                zIndex: 2,
                              }}
                            >
                              <p style={{ fontSize: "1.3rem" }} className="text-center mb-0 text-white">
                                {ticket.journeyHeading}
                              </p>
                            </div>
                          </div>

                          <div id="firstBehind" className={ticket.active ? "active" : ""}>
                            {chunks.map((chunkObj, i) => {
                              const isLastChunk = i === chunks.length - 1;

                              return (
                                <div
                                  key={i}
                                  id="second"
                                  className={ticket.active ? "active" : ""}
                                  style={{
                                    transform: ticket.active
                                      ? `rotate3d(1, 0, 0, -180deg)`
                                      : `rotate3d(1, 0, 0, 0deg)`,
                                    transition: ticket.active
                                      ? `transform 0.9s, height 0.5s`
                                      : `transform 0.6s, height 0.6s`,
                                    transitionDelay: ticket.active
                                      ? `${i * chunkDelay + extraDelay}s`
                                      : `${(totalChunks - i) * chunkDelay}s`,
                                    transformOrigin: ticket.active ? "bottom" : "",
                                    height: ticket.active ? `${chunkObj.height}px` : "0px",
                                    maxHeight: isLastChunk ? "100%" : "145px",
                                    position: isLastChunk ? "relative" : "relative",
                                    top: isLastChunk ? `${145 - chunkObj.height}px` : "",

                                  }}
                                  onTransitionEnd={() =>
                                    handleChunkState(ticket, i, chunks.length)
                                  }
                                >


                                  <div id="secondBehind" style={{
                                    maxHeight: isLastChunk ? `${145 + 10}px` : "",
                                    borderBottom: isLastChunk ? "2px  solid rgba(231, 225, 225, 0.63" : "",
                                    boxShadow: isLastChunk ? "    0px 25px 20px -20px rgba(17, 17, 26, 0.1), 25px 0px 20px -20px rgba(17, 17, 26, 0.1),   -25px 0px 20px -20px rgba(17, 17, 26, 0.1)" : ""
                                  }} >
                                    {chunkObj.isFirstChunk && (
                                      <div
                                        className="flex justify-center flex-col items-center"
                                        style={{
                                          maxHeight: "95px",
                                          minHeight: "95px",
                                          height: "95px",
                                          margin: "0",
                                          padding: "0",
                                        }}
                                      >
                                        <div
                                          className="text-center p-2"
                                          style={{
                                            fontSize: "21px",
                                            margin: "0",
                                            padding: "0",
                                          }}
                                        >
                                          {ticket.text}
                                        </div>
                                        <img
                                          className="mobileversion"
                                          style={{
                                            position: "relative",
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "1.4rem",
                                            minWidth: "100%",
                                          }}
                                          src="/img/ic_weddingline.svg"
                                          alt=""
                                        />
                                      </div>
                                    )}
                                    <p
                                      style={{
                                        textAlign: "justify",
                                        textAlignLast: "justify",
                                        textAlignLast: isLastChunk ? "left" : "justify", // Left-align the last item

                                        display: "block",
                                      }}
                                    >
                                      {chunkObj.chunk}
                                    </p>
                                    <div
                                      id="third"
                                      className={ticket.active ? "active" : ""}
                                      style={{
                                        transform: ticket.active
                                          ? `rotate3d(1, 0, 0, -180deg)`
                                          : `rotate3d(1, 0, 0, 0deg)`,
                                        transition: ticket.active
                                          ? `transform 0.6s, height 0.3s`
                                          : `transform 0.0s`,
                                        transitionDelay: ticket.active
                                          ? `${i * chunkDelay + extraDelay}s`
                                          : `${(totalChunks - i) * chunkDelay}s`,
                                      }}
                                    >
                                      <div id="thirdTop" />
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                );
              })}
          </div>


          <div className="flex flex-col flex-wrap justify-start items-center">
            {ticketsOdd
              .filter((ticket) => ticket.id !== 0)
              .map((ticket) => {
                const chunks = calculateChunks(ticket);
                const totalChunks = chunks.length;
                const chunkDelay = 0.38;
                const extraDelay = 0.25;

                return (
                  <li className="w-full carddiv flex justify-center p-2" key={ticket.id}>
                    <a
                      className="nav-link rounded"
                      id="proposal"
                      data-bs-toggle="pill"
                      href={"#" + ticket.id}
                      role="tab"
                      aria-controls="developing"
                      aria-selected="false"
                    >
                      <div
                        id="cardContainer"
                        style={{
                          transition: "1.9s",
                          pointerEvents: disabledCards.includes(ticket.id) ? 'none' : 'auto',

                        }}

                        onClick={(e) => handleActive(ticket.id, e)}
                      >
                        <div className="firstDisplayImg">
                          <div id="firstDisplay">
                            <img
                              src={ticket.img}
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                              }}
                              className={`
									transition-all duration-500 ${
                    isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                }
									`}
															onLoad={() => setIsImageLoaded(false)}
                              alt=""
                            />
                          </div>
                        </div>
                        <div
                          id="first"
                          className={
                            ticket.active ? "firstheight active" : "firstheight"
                          }
                          style={{
                            transform: ticket.active
                              ? `rotate3d(1, 0, 0, -180deg)`
                              : `rotate3d(1, 0, 0, 0deg)`,
                            transitionDelay: ticket.active
                              ? "0.4s"
                              : `${totalChunks * chunkDelay}s`,

                          }}
                        >
                          <div id="firstTop">
                            <div
                              id="timecontainer"
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                              }}
                            >
                              <img
                                src={ticket.img}
                                style={{
                                  height: "100%",
                                  width: "100%",
                                  objectFit: "cover",
                                }}
                                className={`
									transition-all duration-500 ${
                    isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                }
									`}
															onLoad={() => setIsImageLoaded(false)}
                                alt=""
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0%",
                                  bottom: "0%",
                                  left: "0%",
                                  right: "0%",
                                  background: "rgba(0, 0, 0, 0.4)",
                                  zIndex: 2,
                                }}
                              ></div>
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                top: "12%",
                                bottom: "12%",
                                left: "5%",
                                right: "5%",
                                zIndex: 3,
                              }}
                            >
                              <div className="top-border"></div>
                              <div className="bottom-border"></div>
                              <div className="left-border"></div>
                              <div className="right-border"></div>
                            </div>
                            <div
                              style={{
                                position: "absolute",
                                top: "0%",
                                left: "0%",
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                zIndex: 2,
                              }}
                            >
                              <p style={{ fontSize: "1.3rem" }} className="text-center mb-0 text-white">
                                {ticket.journeyHeading}
                              </p>
                            </div>
                          </div>

                          <div id="firstBehind" className={ticket.active ? "active" : ""}>
                            {chunks.map((chunkObj, i) => {
                              const isLastChunk = i === chunks.length - 1;

                              return (
                                <div
                                  key={i}
                                  id="second"
                                  className={ticket.active ? "active" : ""}
                                  style={{
                                    transform: ticket.active
                                      ? `rotate3d(1, 0, 0, -180deg)`
                                      : `rotate3d(1, 0, 0, 0deg)`,
                                    transition: ticket.active
                                      ? `transform 0.6s, height 0.5s`
                                      : `transform 0.6s, height 0.6s`,
                                    transitionDelay: ticket.active
                                      ? `${i * chunkDelay + extraDelay}s`
                                      : `${(totalChunks - i) * chunkDelay}s`,
                                    transformOrigin: ticket.active ? "bottom" : "",
                                    height: ticket.active ? `${chunkObj.height}px` : "0px",
                                    maxHeight: isLastChunk ? "100%" : "145px",
                                    position: isLastChunk ? "relative" : "relative",
                                    top: isLastChunk ? `${145 - chunkObj.height}px` : "",
                                  }}
                                  onTransitionEnd={() =>
                                    handleChunkState(ticket, i, chunks.length)
                                  }
                                >
                                  <div id="secondBehind" style={{
                                    maxHeight: isLastChunk ? `${145 + 10}px` : "",

                                    borderBottom: isLastChunk ? "2px  solid rgba(231, 225, 225, 0.63" : "",
                                    boxShadow: isLastChunk ? "    0px 25px 20px -20px rgba(17, 17, 26, 0.1), 25px 0px 20px -20px rgba(17, 17, 26, 0.1),   -25px 0px 20px -20px rgba(17, 17, 26, 0.1)" : ""
                                  }} >
                                    {chunkObj.isFirstChunk && (
                                      <div
                                        className="flex justify-center flex-col items-center"
                                        style={{
                                          maxHeight: "95px",
                                          minHeight: "95px",
                                          height: "95px",
                                          margin: "0",
                                          padding: "0",
                                        }}
                                      >
                                        <div
                                          className="text-center p-2"
                                          style={{
                                            fontSize: "21px",
                                            margin: "0",
                                            padding: "0",
                                          }}
                                        >
                                          {ticket.text}
                                        </div>
                                        <img
                                          className="mobileversion"
                                          style={{
                                            position: "relative",
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "1.4rem",
                                            minWidth: "100%",
                                          }}
                                          src="/img/ic_weddingline.svg"
                                          alt=""
                                        />
                                      </div>
                                    )}
                                    <p
                                      style={{
                                        textAlign: "justify",
                                        display: "block",
                                      }}
                                    >
                                      {chunkObj.chunk}
                                    </p>
                                    <div
                                      id="third"
                                      className={ticket.active ? "active" : ""}
                                      style={{
                                        transform: ticket.active
                                          ? `rotate3d(1, 0, 0, -180deg)`
                                          : `rotate3d(1, 0, 0, 0deg)`,
                                        transition: ticket.active
                                          ? `transform 0.6s, height 0.3s`
                                          : `transform 0.0s`,
                                        transitionDelay: ticket.active
                                          ? `${i * chunkDelay + extraDelay}s`
                                          : `${(totalChunks - i) * chunkDelay}s`,
                                      }}
                                    >
                                      <div id="thirdTop" />
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                );
              })}
          </div>
        </ul>
        {/* <div className="frame"></div> */}
      </div>
    </div>
  );
};

export default Journey;
